import { ColorTokens, IconTokens, SizeTypeTokens, WIDGET } from '@voltmoney/schema';
import { POSITION } from '@voltmoney/types';
import { api, config } from '../../../configs/api';
import { APP_CONFIG, getAppHeader, } from '../../../configs/config';
import { ROUTE } from '../../../routes';
import SharedPropsService, { BUILD_TYPE, getBuildType } from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { ACTION, } from './types';
import { getRazorpayKey, isFromAndroidWebview, isFromiOSBrowser, RAZOR_PAY_PREFERRED_METHOD } from '../../../configs/utils';
import { Platform } from "react-native";
import { isIframe } from "../../payment/paymentStart/actions";
import { LENDER_ID, REPAYMENT_COLLECTION_TYPE } from '../../../configs/constants';
//@ts-ignore
import ThemeProvider from "@voltmoney/theme";
import { handlePayment, handleWebPayment } from '../../../configs/utils';
import { getParameters } from '../../../configs/uri-config-utils';
const theme = ThemeProvider.getTheme();
const colorMapping = theme.colors;
let timer;
export const enhanceLimit = async (action, _datastore, { instrumentTrack, navigateToBase, network, ...props }) => {
    const user = await sharedPropsService.getUser();
    const creditId = user.linkedCredits[0].creditId;
    const response = await network.get(`${api.initForeclosureOtp}${creditId}`, {
        headers: await getAppHeader(),
    });
    if (response.status === 200) {
    }
};
export const resetPage = async (action, _datastore, { network, setDatastore, navigateWithClear, removeWidgets, appendWidgets }) => {
    await removeWidgets(ROUTE.OUTSTANDING_DUES, [
        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
        { id: "keyboardSpace", type: WIDGET.SPACE },
        { id: "keyboardSpace2", type: WIDGET.SPACE },
        { id: "keyboardSpace3", type: WIDGET.SPACE },
    ]);
    clearInterval(timer);
    await navigateWithClear(ROUTE.DASHBOARD);
};
export const leadToPayment = async (action, _datastore, { network, appendWidgets, openNewTab, removeWidgets, showPopup, setDatastore, goBack, navigate, navigateToBase, instrumentTrack, }) => {
    instrumentTrack('PAY_DUES_BOTTON_CLICKED', {
        source_page: 'FORECLOSURE',
    });
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
    const netPayable = action?.payload?.creditResponse?.netPayable;
    let popupWindow;
    const user = await SharedPropsService.getUser();
    const test_numbers_bajaj_pg = await SharedPropsService.getFirebaseConfig()?.test_numbers_bajaj_pg;
    if (!test_numbers_bajaj_pg) {
        return false;
    }
    const test_numbers_bajaj_pg_object = JSON.parse(test_numbers_bajaj_pg);
    const bajajPgPhoneNumbers = test_numbers_bajaj_pg_object?.numbers;
    let showBajajPg = await SharedPropsService.getFirebaseConfig()?.show_bajaj_pg_foreclosure;
    let buildType = getBuildType();
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = getParameters(url);
    const platformCode = params?.platform || '';
    let enableBajajPG = false;
    if (platformCode === undefined || platformCode === null || platformCode === '') {
        enableBajajPG = true;
    }
    else
        enableBajajPG = false;
    // @ts-ignore
    let isPaymentModeBajaj = enableBajajPG && (showBajajPg === true || showBajajPg === "true" || bajajPgPhoneNumbers.includes(user.user.phoneNumber)) && (userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId !== "Tata");
    const lenderAccountId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
    const amount = action?.payload?.creditResponse?.netPayable;
    let tataFlag = false;
    if (lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase()) {
        const accountId = userContextResponse?.data.linkedApplications[0].accountId;
        const response = await network.get(`${api.isTataMergerEnabled}${accountId}`, { headers: await getAppHeader() });
        tataFlag = response?.data?.isEnabled;
    }
    await setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
        loading: true
    });
    if (lenderAccountId?.toLowerCase() === LENDER_ID.DSP.toLowerCase()) {
        let redirectionUrl = isFromAndroidWebview() || isFromiOSBrowser() ? `${window?.location?.href}` : `${config.APP_URL}`;
        const response = await network.post(`${api.collectionNew}`, {
            baseOriginUrl: redirectionUrl,
            paymentGatewayIntegrationType: 'PG_SDK',
            collectionAmount: `${amount}`,
            creditId: userCreditId,
            redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
            collectionType: `${REPAYMENT_COLLECTION_TYPE.FORECLOSURE}`
        }, { headers: await getAppHeader() });
        if (response?.status === 200) {
            const timeout = 600;
            const collectionId = response?.data?.collectionId;
            const currentOrderId = response?.data?.pgPaymentOrderId;
            const key = getRazorpayKey();
            const user = userContextResponse?.data;
            const color = colorMapping[ColorTokens.Primary_100];
            let preferredMethod = [''];
            const redirectingRoute = ROUTE.OUTSTANDING_DUES;
            if (amount <= 2000) {
                preferredMethod = RAZOR_PAY_PREFERRED_METHOD.LESS_THAN_2K;
            }
            else if (amount <= 100000) {
                preferredMethod = RAZOR_PAY_PREFERRED_METHOD.LESS_THAN_100K;
            }
            else {
                preferredMethod = RAZOR_PAY_PREFERRED_METHOD.DEFAULT;
            }
            if (Platform.OS === 'web') {
                await handleWebPayment(user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute);
            }
            else {
                await handlePayment(user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute);
            }
        }
    }
    else {
        await network.post(`${api.requestForeclosureCollection}`, {
            baseOriginUrl: Platform.OS === 'web' ? `${config.APP_URL}` : 'https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false',
            creditId: userCreditId,
            paymentGatewayType: isPaymentModeBajaj ? "BAJAJ" : null,
            redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false
        }, { headers: await getAppHeader() })
            .then(res => {
            if (res.status === 200) {
                const isFromTata = userContextResponse.data.linkedCredits[0].lendingPartnerId = "Tata";
                if (Platform.OS !== 'web') {
                    console.warn("LINK RECEIVED IS", res.data.paymentLink);
                    appendWidgets(ROUTE.OUTSTANDING_DUES, {
                        repayLoanWebView: {
                            iframe: false,
                            uri: res.data.paymentLink,
                            doFormPost: isPaymentModeBajaj ? true : false,
                            billDeskCancelAction: {
                                type: ACTION.CANCEL_ACTION,
                                routeId: ROUTE.OUTSTANDING_DUES
                            }
                        },
                        keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                        keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                        keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                        spaceXXL: { size: SizeTypeTokens.XXL }
                    }, [
                        { id: "spaceXXL", type: WIDGET.SPACE },
                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW, padding: { horizontal: 16, vertical: 16 } },
                        { id: "keyboardSpace", type: WIDGET.SPACE },
                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                    ], "manageLimit");
                    removeWidgets(ROUTE.OUTSTANDING_DUES, [
                        {
                            id: "manageLimit",
                            type: WIDGET.OUTSTANDING_DUES,
                        }
                    ]);
                    const runPollar = async () => {
                        network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "OUTSTANDING_DUES" }).then((response) => {
                            if (response.data.collectionStatus !== 'REQUESTED') {
                                clearInterval(timer);
                                removeWidgets(ROUTE.OUTSTANDING_DUES, [
                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    { id: "spaceXXL", type: WIDGET.SPACE }
                                ]);
                                navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                            }
                        });
                    };
                    const timer = setInterval(() => {
                        runPollar();
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
                else {
                    if ((isIframe() || isFromAndroidWebview()) && !isPaymentModeBajaj) {
                        showPopup({
                            isAutoTriggerCta: true,
                            type: 'DEFAULT',
                            iconName: IconTokens.Redirecting,
                            title: 'Waiting for response',
                            subTitle: 'Please wait while we process your request',
                            primary: false,
                        });
                        const url = res.data.paymentLink;
                        // Popup window size
                        const width = isFromTata ? 1002 : 504;
                        const height = 704;
                        // Calculate the position to center the popup on the screen
                        const left = (window.innerWidth - width) / 2;
                        const top = (window.innerHeight - height) / 2;
                        if (isFromAndroidWebview()) {
                            popupWindow = window.open(url, "_blank");
                        }
                        else {
                            popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                        }
                    }
                    else {
                        if (isFromTata) {
                            if (lenderAccountId.toLowerCase() === "bajaj" && isPaymentModeBajaj) {
                                if (isIframe()) {
                                    const form = document.createElement('form');
                                    form.method = 'POST';
                                    form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                        : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment';
                                    form.target = 'paymentPopup'; // Add target for the popup window
                                    // Create an input element
                                    const input = document.createElement('input');
                                    input.type = 'hidden';
                                    input.name = 'msg';
                                    input.value = res.data.paymentLink;
                                    popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                    // Append input to form
                                    form.appendChild(input);
                                    document.body.appendChild(form);
                                    form.submit();
                                }
                                else {
                                    const form = document.createElement('form');
                                    form.method = 'POST';
                                    form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                        : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment';
                                    form.target = 'paymentPopup'; // Add target for the popup window
                                    // form.target = 'paymentPopup'; // Add target for the popup window
                                    // Create an input element
                                    const input = document.createElement('input');
                                    input.type = 'hidden';
                                    input.name = 'msg';
                                    input.value = res.data.paymentLink;
                                    //  popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                    // Append input to form
                                    form.appendChild(input);
                                    document.body.appendChild(form);
                                    form.submit();
                                }
                                // Open a new popup window with the specified size
                            }
                            else {
                                const tataPaymentLink = res.data.paymentLink;
                                window.open(tataPaymentLink, "_self");
                                setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
                                    loading: false
                                });
                            }
                        }
                        else {
                            appendWidgets(ROUTE.PAYMENT_START, {
                                repayLoanWebView: {
                                    iframe: Platform.OS === 'web',
                                    uri: res.data.paymentLink
                                },
                                keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                                keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                                keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                            }, [
                                { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                { id: "keyboardSpace", type: WIDGET.SPACE },
                                { id: "keyboardSpace2", type: WIDGET.SPACE },
                                { id: "keyboardSpace3", type: WIDGET.SPACE },
                            ], "header");
                            removeWidgets(ROUTE.PAYMENT_START, [
                                {
                                    id: "totalAmountShowStack",
                                    type: WIDGET.CARD,
                                    padding: {
                                        horizontal: 0,
                                        all: 0,
                                    },
                                    position: POSITION.ABSOLUTE_TOP,
                                },
                                {
                                    id: "spaceLG",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "titleStack",
                                    type: WIDGET.STACK,
                                },
                                {
                                    id: "spaceXXXL",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "selectFullAmountStack",
                                    type: WIDGET.STACK
                                },
                                {
                                    id: "spaceXXXL",
                                    type: WIDGET.SPACE
                                },
                                {
                                    id: "divider",
                                    type: WIDGET.DIVIDER
                                },
                                {
                                    id: "partialAmountFullStack",
                                    type: WIDGET.STACK
                                },
                                {
                                    id: "proceedButtonStack",
                                    type: WIDGET.STACK,
                                    position: POSITION.ABSOLUTE_BOTTOM
                                },
                                {
                                    id: "spaceLG",
                                    type: WIDGET.SPACE
                                },
                                { id: "enterAmountFullStack", type: WIDGET.STACK },
                                { id: "amountMessage", type: WIDGET.TEXT }
                            ]);
                            setDatastore(action.routeId, "customHeader", {
                                title: (isFromTata)
                                    ? (tataFlag
                                        ? "Paying to Tata Capital Limited"
                                        : "Paying to Tata Capital Financial Services Ltd.")
                                    : "Paying to Bajaj Finance"
                            });
                        }
                    }
                    if (isIframe()) {
                        const runPollar = async () => {
                            network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }, async () => {
                                return;
                            }, {
                                disableDefault: true
                            }).then((response) => {
                                if (popupWindow.closed) {
                                    goBack();
                                    clearInterval(timer);
                                }
                                else {
                                    if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                        removeWidgets(ROUTE.PAYMENT_START, [
                                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                            { id: "keyboardSpace", type: WIDGET.SPACE },
                                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                                        ]);
                                        clearInterval(timer);
                                        if (popupWindow) {
                                            popupWindow.close(); // Close the popup window if it exists
                                        }
                                        navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                    }
                                }
                            });
                        };
                        timer = setInterval(() => {
                            runPollar();
                        }, APP_CONFIG.POLLING_INTERVAL);
                    }
                }
            }
            else {
                setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
                    loading: false
                });
            }
        });
    }
};
export const verifyOtp = async (action, _datastore, { setDatastore, network, goBack }) => {
    const user = await SharedPropsService.getUser();
    const phoneNumber = user.user.phoneNumber;
    const response = await network.post(`${api.verifyForeclosureOtp}`, {
        // @ts-ignore
        otp: action.payload.otp,
        // @ts-ignore
        phoneNo: phoneNumber
    }, {
        headers: await getAppHeader(),
        handleFromMF: true
    });
    if (response.status === 200) {
    }
    else {
        console.warn("Error received is $$$$$ ", response.response.data.voltErrorCode);
        await setDatastore(action.routeId, 'manageLimit', {
            error: true,
            userName: response.response.data.message
        });
    }
};
export const getURL = async (action, _datastore, { setDatastore, network, showPopup, instrumentTrack }) => {
    instrumentTrack('EMAIL_HOLDING_STATEMENT_BUTTON_CLICKED');
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    const user = await sharedPropsService.getUser();
    const accountId = user.linkedBorrowerAccounts[0].accountId;
    const response = await network.get(`${api.pdfHoldingStatement}${accountId}`, {
        headers: await getAppHeader(),
    });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'continue', {
            loading: false,
        });
        showPopup({
            id: 'bt_outStandingDues_continue',
            autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
            type: 'SUCCESS',
            title: 'Email sent successfully',
            subTitle: 'Account holding details have been sent to your email address.',
            ctaLabel: 'Continue',
            ctaAction: {
                type: ACTION.MENU,
                routeId: ROUTE.MANAGE_LIMIT,
                payload: {},
            },
            primary: false,
        });
    }
    await setDatastore(action.routeId, 'continue', {
        loading: false,
    });
};
export const navigation = async (action, _datastore, { navigate, setDatastore, showPopup, asyncStorage, instrumentTrack }) => {
    console.warn("*** navigationAction props ***", action);
    // @ts-ignore
    const routeId = action.payload.routeId;
    await navigate(routeId);
};
export const goBack = async (action, _datastore, { navigate, goBack, removeWidgets }) => {
    await goBack();
    await removeWidgets(ROUTE.FORECLOSURE, [
        { id: "manageLimit", type: WIDGET.LOAN_FORECLOSURE }
    ]);
};
export const needHelp = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.CONTACT_US_CARD);
};
export const excessAmountHandleAction = async (action, _datastore, { setDatastore, network, navigate, instrumentTrack }) => {
    instrumentTrack('GET_REFUNDS_BUTTON_CLICKED', {
        source_page: 'FORECLOSURE',
    });
    await setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
        excessAmountLoader: true
    });
    const user = await SharedPropsService.getUser();
    const creditId = user?.linkedCredits[0]?.creditId;
    const excessAmount = action?.payload?.excessAmount;
    const response = await network.post(`${api.foreclosureExcessAmountHandling}${creditId}`, {
        excessAmount: excessAmount
    }, {
        headers: await getAppHeader(),
    });
    if (response?.status === 200) {
        await setDatastore(ROUTE.OUTSTANDING_DUES, "manageLimit", {
            excessAmountLoader: false
        });
        await navigate(ROUTE.DASHBOARD);
    }
};
